import { baseInstance } from "axios/instances";

export const conversation = async (content: string) => {
    const res = await baseInstance.post("/chat/conversation", { content });
    return res.data
};